<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr"
        min-width="600px"
        max-width="800px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card>
            <v-card-title>E-Mail senden</v-card-title>
            <v-divider />
            <v-card-text class="mt-8">
                <v-row>
                    <v-col class="h5 mt-1 mb-3 pr-0" cols="2">Empfänger</v-col>
                    <v-col cols="10">
                        <div>{{ emailAddress }}</div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="h5 mt-3" cols="2">Betreff</v-col>
                    <v-col cols="10">
                        <v-text-field
                            v-model="mailSubject"
                            label="Betreff"
                            outlined
                            hide-details
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="h5 mt-3" cols="2">Text</v-col>
                    <v-col cols="10">
                        <v-textarea
                            v-model="mailBody"
                            rows="10"
                            label="Text"
                            outlined
                            hide-details
                            dense
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                    @click="sendMail"
                    :disabled="!mailSubject.trim().length || !mailBody.trim().length"
                    color="success"
                    class="send-mail"
                    depressed
                >
                    Absenden
                </v-btn>
                <v-btn
                    @click="isOpen = false"
                    outlined
                    color="secondary"
                >
                    Abbrechen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            emailAddress: '',
            mailSubject: '',
            mailBody: '',
            pw: ''
        }
    },
    props: {
        value: Boolean,
        pharmacyId: String,
        mailTemplate: String
    },
    methods: {
        async getMailContent() {
            try {
                const response = await axios(`/pharmacies/${this.pharmacyId}/mail_password_msg`, {
                    params: { template: this.mailTemplate }
                });
                const mail = response.data;
                this.emailAddress = mail.email;
                this.mailSubject = mail.subject;
                this.mailBody = mail.msg
                this.pw = mail.pw ?? '';
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.alertError('User not found for the pharmacy.');
                    this.isOpen = false;
                } else {
                    this.alertError()
                }
            }
        },
        async sendMail() {
            try {
                const response = await axios.post(`/pharmacies/${this.pharmacyId}/mail_password_send`, {
                    email: this.emailAddress,
                    subject: this.mailSubject,
                    msg: this.mailBody,
                    tmpl_name: this.mailTemplate,
                    pw: this.pw
                });
                this.alertSuccess(`Mail erfolgreich an ${this.emailAddress} geschickt.`);
                this.value = false
            } catch (error) {
                this.alertError(error.response.data.message);
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success',
        })
    },
    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state)
            }
        },
    },
    watch: {
        isOpen(isOpen) {
            if (isOpen) {
                this.getMailContent()
            }
        }
    },
}
</script>

<style></style>